import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jianguan",
  "use": "icon-jianguan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-jianguan\"><defs><style type=\"text/css\"></style></defs><path d=\"M832 128H192c-38.4 0-64 25.6-64 64v492.8c0 38.4 25.6 64 64 64h640c38.4 0 64-25.6 64-64V192c0-38.4-25.6-64-64-64zM390.4 556.8h-64V409.6h64v147.2z m153.6 0h-64V320h64v236.8z m153.6 0h-64V384h64v172.8zM281.6 832h454.4v64H281.6z\" p-id=\"3992\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol